import React, { Component } from 'react';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import Subjects from '../pages/subjects';


export default class ViewQuestionBankArchive extends Component{

    constructor(props){
        super(props);

        this.state={
            loadingArchivedList:true,
            archivedQBs:[],
            selectedQBID:undefined
        }
    }

    componentWillMount(){
        this.getArchivedQuestionBanks();
    }

    onQBSelected = (value, index, event, details) =>{
        this.setState({selectedQBID:value});
    }

    getArchivedQuestionBanks = async() =>{
        this.setState({loadingArchivedList:true});
        try{
            let getArchivedQuestionBanksResponse = await ApiRequestService({
                method: 'post',
                url:'getArchivedQBs',
                data: ''
            })
            if(getArchivedQuestionBanksResponse.data !== undefined && getArchivedQuestionBanksResponse.data !== null){
                if(getArchivedQuestionBanksResponse.data.status === 0 && getArchivedQuestionBanksResponse.data.data !== undefined && 
                    getArchivedQuestionBanksResponse.data.data !== null){
                    this.setState({'archivedQBs':getArchivedQuestionBanksResponse.data.data });
                }else if (getArchivedQuestionBanksResponse.data.message !== undefined &&  
                    getArchivedQuestionBanksResponse.data.message !== null ) {
                    NotificationManager.error("No Data Found.");
                }else{
                    NotificationManager.error("No Data Found.");
                }
            }else{
                NotificationManager.error("No Data Found.");
            }
        }catch(err){

            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingArchivedList:false});
        }
    }

    render(){
        if(this.state.loadingArchivedList)
            return <LoadingSpinner/>
            return  <SecureShow targetRole={1} >
            <Subjects replaceBreadCrumb={this.props.replaceBreadCrumb} archive_mode={true} archive_id={1}/>
        </SecureShow>
    }

}